import React from "react"
import PropTypes from "prop-types"
import LargeTextCell from "sheets/components/cells/LargeTextCell"
import { cleanUpHtml, replaceAtMentionsWithTags } from 'shared/imports/sharedHelperFunctions'

export const MentionableDefaultCell = props => (
    <LargeTextCell
        {...props}
        cellValue={replaceAtMentionsWithTags(props.cellValue)}
    >
        <div
            className='comment-text'
            dangerouslySetInnerHTML={
                {__html: replaceAtMentionsWithTags(cleanUpHtml(props.children))}
            }
        />

    </LargeTextCell>
)

MentionableDefaultCell.propTypes = {
    cellValue: PropTypes.any.isRequired
}

export default MentionableDefaultCell
